export default __webpack_public_path__ + "images/fn-invoice-header.png";